import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { NewVersionBanner } from '@/components/NewVersionBanner';
import { Sidebar } from '@/components/Sidebar';
import { Topbar } from '@/components/Topbar';
import { FavoriteStar } from '@/components/FavoriteMenus';
import { PageTitleAddonProvider } from '@/components/ui';
import { Toaster } from '@/components/ui';
import { CommandPalette } from '@/features/dashboard/components/CommandPalette';
import { useGlobalShortcuts } from '@/features/dashboard/hooks/useGlobalShortcuts';
import { useScrollTopOnNavigate } from './useScrollTopOnNavigate';

export const RootLayout = () => {
  const [paletteOpen, setPaletteOpen] = useState(false);
  // 200(b) — 모바일(<md) 사이드바 오프캔버스 드로어 상태. 데스크톱(md+)에서는 사이드바가 상시
  // 인-플로우라 이 상태와 무관하다.
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  useGlobalShortcuts({ onCommandPalette: () => setPaletteOpen(true) });
  useScrollTopOnNavigate();

  // 라우트 변경 시 모바일 드로어 자동 닫힘(이동 후 본문이 가려지지 않도록).
  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname]);

  return (
    <div
      className="flex min-h-dvh items-start text-[color:var(--content-default)]"
      style={{ background: 'var(--surface-1)' }}
    >
      <Sidebar mobileOpen={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />
      {/* 200(b) — 모바일 드로어 백드롭(<md 에서 드로어 열렸을 때만). 클릭 시 닫힘. md+ 무영향. */}
      {sidebarOpen ? (
        <button
          type="button"
          aria-label="사이드바 닫기"
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
        />
      ) : null}
      <div className="relative flex min-w-0 flex-1 flex-col">
        <NewVersionBanner />
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1">
          {/* Linear/모던 SaaS 어드민: 데이터 밀도를 위해 와이드 컨테이너(1600).
           * 풀 edge-to-edge 는 폼 가독성을 해쳐 1600 으로 캡 — 와이드 모니터에서
           * 테이블 가로 공간 확보 + 울트라와이드에서 라인길이 제한. (T2 재검토) */}
          <div className="mx-auto w-full max-w-[1600px] px-6 py-6 lg:px-8 lg:py-8">
            {/* QA-509 페이지 제목 옆 즐겨찾기 별. */}
            <PageTitleAddonProvider addon={<FavoriteStar />}>
              <Outlet />
            </PageTitleAddonProvider>
          </div>
        </main>
      </div>
      <CommandPalette open={paletteOpen} onOpenChange={setPaletteOpen} />
      <Toaster />
    </div>
  );
};
